module.exports = __webpack_public_path__ + "img/2@3x.262f845f.png";